import { render, staticRenderFns } from "./PermissionModel.vue?vue&type=template&id=70b491ef&scoped=true"
import script from "./PermissionModel.vue?vue&type=script&lang=js"
export * from "./PermissionModel.vue?vue&type=script&lang=js"
import style0 from "./PermissionModel.vue?vue&type=style&index=0&id=70b491ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b491ef",
  null
  
)

export default component.exports